import axios from 'axios';

const API_BASE_URL =
  window.location.hostname === 'localhost'
    ? 'http://127.0.0.1:8000'          // ローカル開発用
    : 'https://sdgs.ex-link.net'; // 本番 HTTPS
const api = axios.create({
  baseURL: API_BASE_URL,
});

// 🚀 リクエストインターセプターでContent-Typeを動的に設定
api.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    // FormDataのときは multipart/form-data にする
    config.headers['Content-Type'] = 'multipart/form-data';
  } else {
    // それ以外は application/json にする
    config.headers['Content-Type'] = 'application/json';
  }
  return config;
});

export default api;
